<template>
    <div class="md-blog-list broker" translate="yes">
        <site-img
            class="blog-banner"
            :src="picture"
            alt="blog banner"
            :size="2048"
        />
        <form
            v-if="isMobileSize"
            class="search-input-form"
            @submit.prevent="submitHandler"
        >
            <div class="search-input-form-box">
                <input
                    class="search-input"
                    type="text"
                    v-model.trim="keywords"
                    :placeholder="
                        searchInputPlaceholder ||
                            $t('md-blog-list.typeToSearch')
                    "
                />
                <span
                    v-show="keywords"
                    class="iconfont icon-search-close"
                    @click="keywords = ''"
                ></span>
                <button
                    class="iconfont icon-v5-search"
                    @click="submitHandler"
                    :aria-label="$t('md-blog-list.searchBlog')"
                ></button>
            </div>
        </form>
        <module-box
            class="info-container"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            v-if="hasBlogs"
        >
            <div class="left" v-lazy="{ callback: outOffView }" ref="blogs">
                <blog-list
                    :title="blogListInfo.blogListTitle"
                    :list="blogListInfo.blogs"
                    :count="blogListInfo.count"
                />
                <BrokerPagination
                    :updateNavigate="true"
                    :totalPage="blogListInfo.totalPages"
                    @pageChange="pageChange"
                    :pageSize="blogListInfo.pageSize"
                    :pageNum="pageNum"
                    v-if="hasBlogs"
                />
            </div>
            <div
                ref="sidebar"
                class="right"
                :style="{ top: isMobileSize ? 0 : `${sidebarTop}px` }"
            >
                <form
                    v-if="!isMobileSize"
                    class="search-input-form"
                    @submit.prevent="submitHandler"
                >
                    <div class="search-input-form-box">
                        <input
                            class="search-input"
                            type="text"
                            v-model.trim="keywords"
                            :placeholder="
                                searchInputPlaceholder ||
                                    $t('md-blog-list.typeToSearch')
                            "
                        />
                        <span
                            v-show="keywords"
                            class="iconfont icon-search-close"
                            @click="keywords = ''"
                        ></span>
                        <button
                            class="iconfont icon-v5-search"
                            @click="submitHandler"
                            :aria-label="$t('md-blog-list.searchBlog')"
                        ></button>
                    </div>
                </form>
                <module-wrapper theme="broker" :title="categoryTitle">
                    <blog-category
                        :list="categories"
                        :showCategoryCount="showCategoryCount"
                        :categoryId="categoryId"
                        theme="broker"
                    />
                </module-wrapper>
                <module-wrapper
                    theme="broker"
                    v-if="
                        recentPostInfo &&
                            recentPostInfo.list &&
                            recentPostInfo.list.length
                    "
                    :title="recentPostInfo.title"
                >
                    <blog-post
                        theme="broker"
                        :list="recentPostInfo.list"
                        :showDate="recentPostInfo.showDate"
                    />
                </module-wrapper>
            </div>
        </module-box>
        <module-box
            class="container"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            v-else
        >
            <empty-blog></empty-blog>
        </module-box>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import common from '../index';
import blogList from './blog-list';
export default {
    mixins: [common],
    components: {
        blogList,
        BrokerPagination: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/pagination/broker"*/ '@/components/pagination/broker.vue'
            ))
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
    },
    data: function() {
        return {
            defaultPagesize: 4
        };
    },
    mounted() {}
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';

.md-blog-list {
    &.broker {
        .blog-banner {
            height: 350px;
            width: 100%;
            object-fit: cover;
            @include media-600 {
                height: 100px;
                margin-bottom: 20px;
            }
        }
        .info-container {
            display: flex;
            align-items: flex-start;
            margin-top: 30px;
            .left {
                padding-right: 50px;
                width: calc(100% - 290px);
            }

            .right {
                position: relative;
                width: 290px;

                .module-wrapper {
                    margin-top: 30px;
                    .share-btn {
                        text-align: left;
                    }
                }
            }
            @include media-600 {
                margin-top: 20px;
                display: block;
                .left {
                    width: 100%;
                    padding-right: 0;
                }
                .right {
                    width: 100%;
                    display: block;
                }
            }
        }
        .comp-pagination.broker {
            margin-top: 15px;
        }
    }

    .search-input-form {
        height: 44px;
        overflow: hidden;
        box-shadow: var(--box-shadow);
        border-radius: 5px;
        @include media-600 {
            width: calc(100% - 30px);
            margin-left: 15px;
        }
        .search-input-form-box {
            width: 100%;
            height: 100%;
            position: relative;

            .search-input {
                width: calc(100% - 50px);
                height: 100%;
                padding-left: 10px;
                padding-right: 24px;
                outline: none;
                box-shadow: none;
                border: none;
                background-color: #f3f3f3;
                font-size: 16px; /*  and placeholder same font size ， solve IOS placeholder Not centered ( down ) */
                font-family: var(--font-medium);
                &::-webkit-input-placeholder {
                    font-size: 16px;
                    color: #a8a8a8;
                    font-family: var(--font-medium);
                }
            }

            .icon-search-close {
                position: absolute;
                top: 0;
                right: 55px;
                display: inline-block;
                width: auto;
                height: 44px;
                line-height: 44px;
                font-size: 16px;
                text-align: right;
                color: #818692;
                cursor: pointer;
            }

            .icon-v5-search {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 44px;
                float: right;
                cursor: pointer;
                font-size: 24px;
                color: #fff;
                border: 0;
                background: var(--color-theme);
            }
        }
    }
}
</style>
